// Pause/Resume control colors from the design spec. Kept as explicit constants
// (not AntD theme tokens) because the app's `colorError` (#e22020) is a brighter
// red than the design's rose, and no `colorSuccess` token is configured.
export const PAUSE_COLOR = '#ce6c6d'
export const RESUME_COLOR = '#93c33d'

// Solid single-color button style: matching background + border, white label.
export const solidButtonStyle = (color: string) => ({
  backgroundColor: color,
  borderColor: color,
  color: '#ffffff',
})
